export default "__VITE_ASSET__DNhtTdlZ__"